import { useEffect, useState } from "react";
import TopNavBar from "../../components/reusables/topNavBar";
import { toast } from "react-toastify";
import LegalService from "../../rest/legalService";

function LegalDocumentsPage() {
    const [documents, setDocuments] = useState([]);
    const [activeType, setActiveType] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        LegalService.getActiveDocuments()
            .then((docs) => {
                setDocuments(docs || []);
                if (docs && docs.length > 0) setActiveType(docs[0].documentType);
            })
            .catch(() => toast.error("Erro ao carregar os documentos."))
            .finally(() => setLoading(false));
    }, []);

    const activeDocument = documents.find(doc => doc.documentType === activeType);

    return (
        <div className='h-full flex flex-col'>
            <TopNavBar title={"Termos e Privacidade"} subtitle={""} />

            <div className="flex flex-col gap-6 mx-4 md:mx-16 my-6">
                {loading ? (
                    <div className="flex items-center justify-center h-64">
                        <p className="text-custom_gray_font animate-pulse">Carregando documentos...</p>
                    </div>
                ) : documents.length === 0 ? (
                    <p className="text-custom_gray_font">Nenhum documento disponível no momento.</p>
                ) : (
                    <>
                        <div className="flex border-b mb-4 sticky top-0 bg-gray-50 z-20 pt-2">
                            {documents.map(doc => (
                                <button
                                    key={doc.documentType}
                                    className={`px-4 py-2 font-semibold transition-colors ${activeType === doc.documentType ? 'border-b-2 border-custom_blue text-custom_blue' : 'text-gray-500 hover:text-gray-700'}`}
                                    onClick={() => setActiveType(doc.documentType)}
                                >
                                    {doc.title}
                                </button>
                            ))}
                        </div>

                        {activeDocument && (
                            <div className="bg-white rounded-xl border border-gray-100 shadow-sm p-6">
                                <h2 className="font-semibold text-gray-700 text-lg mb-1">{activeDocument.title}</h2>
                                <p className="text-xs text-gray-400 mb-4">Versão {activeDocument.version}</p>
                                <div className="text-sm text-gray-700 whitespace-pre-wrap leading-relaxed">
                                    {activeDocument.content}
                                </div>
                            </div>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}

export default LegalDocumentsPage;
